import { RootState } from '@/store/types';
import {
  ClockInState,
  ClockIn,
  ClockInSearchConditions,
  TutorSchedule,
  Stamp,
} from '@/store/clockIn/types';
import axios from 'axios';
import { Commit, ActionTree } from 'vuex';
import _ from 'lodash';
import moment, { Moment } from 'moment';

axios.defaults.baseURL = 'http://localhost';

const actions: ActionTree<ClockInState, RootState> = {
  fetchClockIns: (
    { commit }: {commit: Commit},
    { date, conditions }: { date: Moment, conditions?: ClockInSearchConditions },
  ) => {
    const params = {
      date: date.format('YYYYMMDD'),
      ..._.pickBy({
        universityCode: conditions?.university?.code,
        type: conditions?.types?.join(','),
        tutor: conditions?.tutor?.name,
        campusCode: conditions?.campuses.map(({ code }) => code)?.join(','),
        programCode: conditions?.subject?.code,
        levelCode: conditions?.levels.map(({ code }) => code)?.join(','),
      }),
    }
    return axios.get('/tutors/attendances', { params }).then((response) => {
      const clockIns: ClockIn[] = _.map(response.data, (d: any): ClockIn => ({
        tutor: d.tutorId && {
          id: d.tutorId,
          name: d.tutorName,
        },
        stamp: d.clockInTime && moment(`${date.format('YYYYMMDD')}${d.clockInTime}`, 'YYYYMMDDHHmm'),
        status: d.status,
        schedules: _.map(d.schedules, (s): TutorSchedule => ({
          startPeriod: s.startPeriod,
          endPeriod: s.endPeriod,
          type: s.type,
          scheduleId: s.scheduleId,
          participationTime: s.substituteTime || s.scheduleParticipantTime,
          course: {
            code: s.courseCode,
          },
          level: {
            code: s.levelCode,
          },
          university: {
            name: s.universityName,
            abbreviation: s.universityAbbreviation,
          },
          campus: {
            name: s.campusName,
            abbreviation: s.campusAbbreviation,
          },
          boothBuilding: {
            building: s.boothBuilding,
          },
          boothRoom: {
            room: s.boothRoom,
          },
          boothNumber: {
            number: s.boothNumber,
          },
        })),
      }))
      commit('fetchedClockIns', clockIns);
    });
  },

  fetchStamps: ({ commit }, payload: { id: string, date: string }) => {
    const reqUrl = `/clockIn/${payload.id}/detail/`;
    const params = { date: payload.date }
    return axios.get(reqUrl, { params }).then((response: any) => {
      const stamps: Stamp[] = _.map(response.data.clockInHistry, (d: any): Stamp => ({
        attendanceId: d.attendanceId,
        type: d.type,
        date: moment(`${d.date}${d.time}`, 'YYYYMMDDHHmm'),
      }))
      commit('fetchedStamps', stamps);
    });
  },

  registerStamp: (
    context,
    payload: {
      userId:string,
      stamp: {
        date: Moment,
        time: number,
        type: string
      },
    },
  ) => {
    const reqUrl = `/tutors/${payload.userId}/attendances/`;
    return axios.post(reqUrl, payload.stamp);
  },

  changeStamp: (
    context,
    payload: {
      attendanceId:string,
      userId:string,
      stamp: {
        date: Moment,
        time: number,
        type: string
      },
    },
  ) => {
    const reqUrl = `/tutors/${payload.userId}/attendances/${payload.attendanceId}`;
    return axios.put(reqUrl, payload.stamp);
  },

  deleteStamp: (context, payload: { attendanceId:string, userId:string }) => {
    const reqUrl = `/tutors/${payload.userId}/attendances/${payload.attendanceId}`;
    return axios.delete(reqUrl);
  },
};

export default actions;
